<div class="d-none d-lg-block">
  <fgb-banner [pageTitle]="name$ | async" />
</div>
<ng-container *ifScreenSize="screenSize.Mobile">
  <fgb-page-header [pageTitle]="'account.nav.profile'" [backButtonLink]="'/'" />
</ng-container>

<div class="container mt-lg-4">
  <div class="row">
    <div class="col-12 col-lg-6">
      <ng-container *ifScreenSize="screenSize.Desktop">
        <h5 class="mb-2 mt-lg-0 fw-bold text-uppercase font-heading">{{ 'account.member.card.title' | translate }}</h5>
        <fgb-member-card></fgb-member-card>
      </ng-container>
    </div>

    <div class="col-12 col-lg-6">
      <h5 class="my-lg-2 my-2 mt-lg-0 fw-bold text-uppercase font-heading">{{ 'account.details.title' | translate }}</h5>
      <fgb-account-details></fgb-account-details>
    </div>
  </div>
</div>
